import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AngularSvgIconModule } from "angular-svg-icon";
import { FlipCoachTargetDirective } from "../coach-mark/coach-mark-target.directive";

@Component({
  selector: "app-star-line-item",
  templateUrl: "./star-line-item.component.html",
  styleUrls: ["./star-line-item.component.scss"],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, FlipCoachTargetDirective],
})
export class StarLineItemComponent {
  @Input() name: string = "";
  /** Registers the + icon as a coach-mark anchor under this key (onboarding SS02, FLIP-372). */
  @Input() addCoachTarget: string | null = null;
  @Output() clicked = new EventEmitter<void>();
}
